import _ from 'underscore';
import Handlebars from 'handlebars';
import links from 'timeline';
import i18n from 'l10n';
import moment from 'moment';
import {serviceBalloonClass, ServiceTypes} from 'js/serviceutil';

export default {
    drawTimeline: function(mode, pageName, groupsChangeableFlag) {
        let self = this;
        if(self.$('#timeline').is(':visible')) {
            links.Timeline.prototype.repaintDeleteButton = function() {}; //No delete button!
            const ld = moment().localeData();
            links.locales['el'] = {
                'MONTHS': ld.months(),
                'MONTHS_SHORT': ld.monthsShort(),
                'DAYS': ld.weekdays(),
                'DAYS_SHORT': ld.weekdaysShort(),
                'ZOOM_IN': "Μεγέθυνση",
                'ZOOM_OUT': "Σμίκρυνση",
                'MOVE_LEFT': "Αριστερά",
                'MOVE_RIGHT': "Δεξιά",
                'NEW': "Νέο",
                'CREATE_NEW_EVENT': "Δημιουργήστε νέο γεγονός"
            };

            links.locales['el_GR'] = links.locales['el'];

            let options = {
                locale: i18n.language,
                minHeight: "500px",
                height: "auto",
                zoomMin: 3600000,
                editable: true,
                timeChangeable: false,
                groupsChangeable: groupsChangeableFlag
            };
            self.timeline = new links.Timeline(self.$('#timeline')[0], options);
            var now = new Date();
            var start = new Date(now.getTime() - 10 * 24 * 60 * 60 * 1000);
            var end = new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000);
            var data = [];
            var savedData = [];
            var getSelectedRow = function () {
                var row = undefined;
                var sel = self.timeline.getSelection();
                if (sel.length) {
                    if (sel[0].row != undefined) {
                        row = sel[0].row;
                    }
                }
                return row;
            };
            var clone = function(data) {
                return _.map(data, function(e) {
                    let o = _.extend({}, e);
                    if(o.start) {
                        o.start = new Date(o.start.getTime());
                    }
                    if(o.end) {
                        o.end = new Date(o.end.getTime());
                    }
                    return o;
                });
            };
            let findDiff = function(old, curr) {
                let delta = {};
                if(old.group != curr.group) {
                    delta.group = curr.group;
                }
                if(old.start.getTime() != curr.start.getTime()) {
                    delta.start = curr.start;
                }
                if(curr.end && old.end.getTime() != curr.end.getTime()) {
                    delta.end = curr.end;
                }
                return delta;
            };
            links.events.addListener(self.timeline, 'edit', function() {
                let sel = getSelectedRow();
                window.location.href = pageName +"#" + data[sel].id;
            });
            let itemChanged = function() {
                let sel = getSelectedRow();
                let curr = data[sel];
                let old = _.find(savedData, (e) => e.id == curr.id);
                let delta = findDiff(old, curr);
                console.log('change ' + sel + ' start=' + delta.start + ' end=' + delta.end + ' group=' + delta.group);
                if(!delta.group) {
                    self.timeline.cancelChange();
                    return;
                }
                if(curr.group != '&nbsp;' && (old.templateType != 'TELLODY_VOUCHER')) {
                    self.timeline.cancelChange();
                    return;
                }
                if(curr.group == '&nbsp;') {
                    curr.group = curr.ownGroup;
                } else {
                    if(curr.status == "ACTIVE" && _.every(_.filter(savedData, (e) => e.group == curr.group), (e) => e.status == "ENDED")) {
                        self.timeline.cancelChange();
                        return;
                    }
                }
                self.timeline.redraw();
                adjustHeight();
                savedData = clone(data);
                $.ajaxDefaultQ({
                    url: '/CampaignCloud/Message/timeline/changeGroup',
                    type: 'POST',
                    data : {
                        id: curr.id,
                        group: delta.group
                    },
                    dataType: 'json'
                }).done(function (outcome) {
                    getTimelineData();
                }).fail(function (data) {
                    $.Notify.error(i18n.t("service.timelineoperationfailed"));
                });
            };
            links.events.addListener(self.timeline, 'changed', itemChanged);
            let adjustHeight = function() {
                setTimeout(function() {
                    var h = self.$('.timeline-frame').css('height');
                    console.log('adjustHeight h=' + h);
                    if(h) {
                        self.$('#timeline').css('height',h);
                    }
                }, 500
                );
            };
            links.events.addListener(self.timeline, 'ready', adjustHeight);
            links.events.addListener(self.timeline, 'rangechanged', function(e) {
                start = e.start;
                end = e.end;
                getTimelineData();
                console.log('rangechanged start=' + start + ' end=' + end);
                adjustHeight();
            });

            var getTimelineData = function() {
                $.ajaxDefaultQ({
                    //url: '/CampaignCloud/cloudui/timeline.json',
                    url: '/CampaignCloud/Message/timeline' + mode,
                    type: 'POST',
                    data : {
                        start: start.getTime(),
                        end: end.getTime()
                    },
                    dataType: 'json'
                }).done(function (ret) {
                    data = ret.data;

                    _.each(data, function (item, index) {
                        if(item.start) {
                            item.start = new Date(Date.parse(item.start));
                        }
                        if(item.end) {
                            item.end = new Date(Date.parse(item.end));
                        }
                        let serviceType = ServiceTypes[item.templateType];
                        item.className = serviceBalloonClass(serviceType, item.id);
                        let newContent = Handlebars.helpers.getIconViaTitleStatusAndDescription(serviceType, item.content, item.status, item.description) + item.content;
                        item.content = newContent;
                    });
                    savedData = clone(data);
                    self.timeline.draw(data);
                    self.timeline.setVisibleChartRange(start, end);
                    adjustHeight();
                }).fail(function (data) {
                    $.Notify.error(i18n.t("service.timelinedatafailed"));
                });
            };
            getTimelineData();
        }
    }
};